import React from "react";
import { Trivia } from "../components/Trivia";

const TriviaPage = () => {
  return (
    <div>
      <Trivia />
    </div>
  );
};

export default TriviaPage;
